class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    if (this.mainDetailsToggle.dataset.hoverOpen === 'true') this.initHoverOpen();
  }

  // Desktop pointer devices: open on hover; a mouse click on the label follows its link.
  // Keyboard users still toggle the menu with Enter/Space (click events with detail === 0).
  initHoverOpen() {
    const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    const summary = this.mainDetailsToggle.querySelector('summary');
    let closeTimer;

    this.addEventListener('mouseenter', () => {
      if (!hoverQuery.matches) return;
      clearTimeout(closeTimer);
      this.mainDetailsToggle.setAttribute('open', '');
      summary.setAttribute('aria-expanded', true);
    });

    this.addEventListener('mouseleave', () => {
      if (!hoverQuery.matches) return;
      closeTimer = setTimeout(() => this.close(), 200);
    });

    summary.addEventListener('click', (event) => {
      const url = this.mainDetailsToggle.dataset.url;
      if (!hoverQuery.matches || event.detail === 0 || !url) return;
      event.preventDefault();
      window.location.href = url;
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
